import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FunctionAppInfo } from '../interfaces/function-app-info.interface';

@Injectable({
	providedIn: 'root',
})
export class FunctionAppInfoService {
	readonly url: string = 'FunctionAppInfo/';
	constructor(private http: HttpClient) {}

	public getFunctionAppInfoById(id: number): Observable<FunctionAppInfo> {
		return this.http.get<FunctionAppInfo>(this.url + id);
	}

	public updateFunctionAppInfoById(id: number, slot: number): Observable<boolean> {
		return this.http.post<boolean>(this.url + '', { linkId: id, slot: slot });
	}

	public deleteFunctionAppInfoById(id: number): Observable<boolean> {
		return this.http.delete<boolean>(this.url + id);
	}
}
